import { useMemo } from "react";

/**
 * useBrowserDetect
 * Определяет браузер пользователя по User-Agent.
 *
 * Возвращает объект:
 *   isSamsungBrowser  — Samsung Internet
 *   isChrome          — Chrome / Chromium
 *   isFirefox         — Firefox
 *   isSafari          — Safari (не Chrome)
 *   isEdge            — Microsoft Edge
 *   isOpera           — Opera
 *   browserName       — строковое имя браузера для отладки
 */
const useBrowserDetect = () => {
  return useMemo(() => {
    const ua = navigator.userAgent || "";

    const isSamsungBrowser = /SamsungBrowser/i.test(ua);
    const isEdge = /Edg\//i.test(ua);
    const isOpera = /OPR\//i.test(ua) || /Opera/i.test(ua);
    // Safari идёт до Chrome, т.к. Chrome тоже содержит "Safari" в UA
    const isSafari = /Safari/i.test(ua) && !/Chrome/i.test(ua);
    const isFirefox = /Firefox/i.test(ua);
    const isChrome = /Chrome/i.test(ua) && !isEdge && !isOpera && !isSamsungBrowser;

    let browserName = "Unknown";
    if (isSamsungBrowser) browserName = "Samsung Internet";
    else if (isEdge) browserName = "Edge";
    else if (isOpera) browserName = "Opera";
    else if (isFirefox) browserName = "Firefox";
    else if (isSafari) browserName = "Safari";
    else if (isChrome) browserName = "Chrome";

    return {
      isSamsungBrowser,
      isChrome,
      isFirefox,
      isSafari,
      isEdge,
      isOpera,
      browserName,
    };
  }, []); // UA не меняется за время сессии — вычисляем один раз
};

export default useBrowserDetect;
